import classNames from 'classnames'
import LogoLink from 'components/logoLink'
import Paragraphs from 'components/home/common/typography/Paragraphs'
import Button, { ButtonProps } from 'components/home/common/Button'

export interface StatusPanelProps {
  text: string
  button: ButtonProps
  className?: {
    container?: string
    logo?: string
    text?: string
    button?: string
  }
}

const StatusPanel = ({
  text,
  button,
  className,
}: StatusPanelProps) => {
  return (
    <div className={classNames('flex flex-col items-center pt-65 pb-40 px-24 gap-y-50', className?.container)}>
      <LogoLink className={classNames('max-w-[110px] w-full', className?.logo)} />

      <Paragraphs.LG className={classNames('text-center !leading-23 px-24', className?.text)}>
        {text}
      </Paragraphs.LG>

      <Button
        className={{
          button: classNames('flex items-center gap-12 max-w-sm', className?.button),
        }}
        block
        {...button}
      >
        {button.children}
      </Button>
    </div>
  )
}

export default StatusPanel
